<template>
  <b-container class="pt-3 pb-3" fluid >
    <!-- User Interface controls -->
    <b-row>
        <b-col cols="12" md="6">
            <b-col>
                <b-form-group label-cols-sm="3" label="เลือกวันที่" class="mb-2">
                    <b-tabs content-class="mt-3" fill>
                        <b-tab title="วัน" active>
                            <div>
                                <a-range-picker
                                  v-model="form.dateRang"
                                  :ranges="{ Today: [moment(), moment()], 'This Month': [moment(), moment().endOf('month')] }"
                                  format="YYYY/MM/DD"
                                  @change="setDate"
                                  style="width: 100%"
                                >
                                    <a-icon slot="suffixIcon" type="smile" />
                                </a-range-picker>
                            </div>
                        </b-tab>
                        <b-tab title="เดือน">
                            <div>
                                <a-range-picker
                                  v-model="form.mouthRang"
                                  :placeholder="['Start month', 'End month']"
                                  format="YYYY-MM"
                                  :mode="['month', 'month']"
                                  @panelChange="setMonth"
                                  style="width: 100%"
                                />
                              </div>
                        </b-tab>
                        <b-tab title="ปี">
                          <a-range-picker
                            v-model="form.yearRang"
                            :placeholder="['Start year', 'End year']"
                            format="YYYY"
                            :mode="['year', 'year']"
                            @panelChange="setYear"
                            style="width: 100%"
                          />
                        </b-tab>
                    </b-tabs>
                </b-form-group>
            </b-col>
        </b-col>
         <b-col cols="12"  md="6">
             <b-col>
                <b-form-group label-cols-sm="3" label="คู่ค้า" class="mb-0">
                    <a-select
                      v-model="form.operator"
                      show-search
                      placeholder="กรุณาเลือกข้อมูล"
                      style="width: 100%"
                      @select="setOperator"
                    >
                     <a-select-option value="">
                        กรุณาเลือกข้อมูล
                      </a-select-option>
                      <a-select-option v-for="(item , index) in getOperator" :key="index" :value="item.name">
                          {{ item.name }}
                      </a-select-option>
                    </a-select>
                </b-form-group>
            </b-col>
             <b-col>
                <b-form-group label-cols-sm="3" label="บัญชีระบบ" class="mb-0">
                    <a-select
                      v-model="form.bankset"
                      show-search
                      placeholder="กรุณาเลือกข้อมูล"
                      style="width: 100%"
                      @select="setBankSets"
                      :disabled="(getBankSet)?false:true"
                    >
                      <a-select-option value="">
                        กรุณาเลือกข้อมูล
                      </a-select-option>
                      <a-select-option v-for="(item , index) in getBankSet" :key="index" :value="item.bankSetName">
                          {{ item.bankSetName }}
                      </a-select-option>
                    </a-select>
                </b-form-group>
            </b-col>
            <b-col style="text-align: right">
                <a class="btn btn-warnig" href="javascript: void(0);" @click="clearSearch()"><i class="fe fe-x mr-1" /> Clear</a>
            </b-col>
         </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
export default {
  computed: {
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
      getOperator: 'getOperator',
      getBankSet: 'getBankSet',
    }),
  },
  data() {
    return {
      valueMonth: [],
      valueYear: [],
      inputDateRank: null,
      inputOperator: null,
      inputUser: null,
      inputUsername: null,
      form: {
        operator: '',
        dateRang: [moment(), moment()],
        mouthRang: [moment(), moment()],
        yearRang: [moment(), moment()],
        bankset: '',
      },
    }
  },
  props: [
    'pageType',
  ],
  methods: {
    moment,
    ...mapActions({
      setDefult: 'setDefult',
      setDateRank: 'setDateRank',
      setOperarCode: 'setOperarCode',
      setBankSet: 'setBankSet',
    }),
    disabledStartDate(startDate) {
      const endDate = this.endDate
      if (!startDate || !endDate) {
        return false
      }
      return startDate.valueOf() > endDate.valueOf()
    },
    disabledEndDate(endDate) {
      const startDate = this.startDate
      if (!endDate || !startDate) {
        return false
      }
      return startDate.valueOf() >= endDate.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    setDate(dates, dateStrings) {
      const startDate = moment(dateStrings[0] + ' 00:00:00').format('YYYY/MM/DD HH:mm:ss')
      const endDate = moment(dateStrings[1] + ' 23:59:59').format('YYYY/MM/DD HH:mm:ss')
      this.setDateRank({ startDate: startDate, endDate: endDate })
    },
    setMonth(value, mode) {
      this.valueMonth = value
      const startDate = moment(value[0]._d).startOf('month').format('YYYY/MM/DD HH:mm:ss')
      const endDate = moment(value[1]._d).endOf('month').format('YYYY/MM/DD HH:mm:ss')
      this.setDateRank({ startDate: startDate, endDate: endDate })
    },
    setYear(value, mode) {
      this.valueYear = value
      const startDate = moment(value[0]._d).startOf('year').format('YYYY/MM/DD HH:mm:ss')
      const endDate = moment(value[1]._d).endOf('year').format('YYYY/MM/DD HH:mm:ss')
      this.setDateRank({ startDate: startDate, endDate: endDate })
    },
    setOperator(value, option) {
      value = this.getOperator[option.key].operatorCode
      this.setOperarCode({ opertorCode: value, type: this.pageType, use: 'getBankSet' })
    },
    setBankSets(value, option) {
      value = this.getBankSet[option.key].bankSetId
      this.setBankSet(value)
    },
    clearSearch() {
      this.form = {
        operator: '',
        dateRang: [moment(), moment()],
        mouthRang: [moment(), moment()],
        yearRang: [moment(), moment()],
        bankset: '',
      }
      this.setDefult({ type: 'bankPayment' })
    },
  },
  async created() {
    await this.setDefult({ type: 'bankPayment' })
  },
}
</script>

<style>

</style>
